import { FC } from 'react';

export const AdvertisementEdgeIcon: FC = () => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68 68C68 59.0409 55.0563 52.7658 46.0972 52.7658C29.052 52.7658 15.2342 38.948 15.2342 21.9028C15.2342 12.9438 8.95896 0.000263382 0 0H68V68Z"
        fill="white"
      />
      <path
        d="M67.9533 0C67.9114 0 67.8896 0.0510129 67.9193 0.0806966C67.949 0.11038 68 0.0886466 68 0.0466679C67.9997 0.0210391 67.979 0.000259757 67.9533 0Z"
        fill="white"
      />
      <path
        d="M49.3387 20.552L37.8627 32.028L35.9773 30.1427L47.452 18.6667H37.3387V16H52.0053V30.6667H49.3387V20.552Z"
        fill="#0D1217"
      />
    </svg>
  );
};

export const AdvertisementEdgeIconDark: FC = () => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68 68C68 59.0409 55.0563 52.7658 46.0972 52.7658C29.052 52.7658 15.2342 38.948 15.2342 21.9028C15.2342 12.9438 8.95896 0.000263382 0 0H68V68Z"
        fill="#161C23"
      />
      <path
        d="M67.9533 0C67.9114 0 67.8896 0.0510129 67.9193 0.0806966C67.949 0.11038 68 0.0886466 68 0.0466679C67.9997 0.0210391 67.979 0.000259757 67.9533 0Z"
        fill="#161C23"
      />
      <path
        d="M49.3387 20.552L37.8627 32.028L35.9773 30.1427L47.452 18.6667H37.3387V16H52.0053V30.6667H49.3387V20.552Z"
        fill="white"
      />
    </svg>
  );
};
